import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { pathOr } from 'ramda';

import { ClassProp } from 'helpers/types';
import Table from 'components/Table';
import {
  TableHeader,
  Direction,
  SortDefaultColumn,
} from 'components/Table/Table';
import { formatDate } from 'helpers/date';

import AddBudget from '../AddBudget';
import { CampaignSummary } from '../../MerchantCampaigns.helpers';

const styles = {
  container: {
    margin: '1.25rem auto !important',
    height: '100% !important',
    boder: 'none',
    backgroundColor: '#fafbfb',
  },
  header: {},
};

type Styles = ClassProp<typeof styles>;
type Props = {
  classes: Styles;
  selectedRowIndex: number;
  campaignSummary: CampaignSummary[];
};

const getTableHeader = (): TableHeader[] => [
  {
    source: ['adjustmentName'],
    label: 'Adjustment Name',
  },
  {
    source: ['insertionOrder', 'ticket'],
    label: 'Insertion Order',
  },
  {
    source: ['adjustmentApprovalDate'],
    label: 'Approval Date',
    transform: (date: string) => formatDate(date, 'MMM DD, YYYY'),
  },
  {
    source: ['adjustmentAmount'],
    label: 'Adjustment Amt',
    transform: (totalBudget: number) => `$${totalBudget}`,
    justify: 'right',
  },
];

const sortDefaultColumn: SortDefaultColumn = {
  name: 'Start Date',
  sortable: ['campaign', 'startDate'],
  direction: Direction.DESCENDING,
};

const secondarySortColumn: SortDefaultColumn = {
  name: 'End Date',
  sortable: ['campaign', 'endDate'],
  direction: Direction.DESCENDING,
};

const BudgetAdjustments: FunctionComponent<Props> = ({
  campaignSummary,
  selectedRowIndex,
  classes,
}) => {
  const budgets = pathOr({}, [selectedRowIndex, 'budgets'], campaignSummary);
  const adjustments = pathOr({}, ['0', 'adjustments'], budgets);
  const tableHeader = getTableHeader();
  return (
    <div className={classes.container}>
      <h3>Budget Adjustments</h3>
      <Table
        tableHeader={tableHeader}
        data={adjustments}
        sortDefaultColumn={sortDefaultColumn}
        sortSecondaryColumn={secondarySortColumn}
        itemsKey="adjustmentId"
      />
      <AddBudget budgets={budgets} />
    </div>
  );
};

export default withStyles(styles)(BudgetAdjustments);
